module.exports = __webpack_public_path__ + "d055eaea.svg";